var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "js-clipper-basic"
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__padding",
    style: _vm.padStyle
  }, [_c('canvas', {
    staticClass: "vuejs-clipper-basic__stem-canvas",
    attrs: {
      "width": _vm.stemArea.width,
      "height": _vm.stemArea.height
    }
  }), _c('div', {
    staticClass: "vuejs-clipper-basic__in-pad",
    style: _vm.inPadStyle
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__img-wrap",
    class: {
      vertical: _vm.isVertical
    }
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__img-scale js-img-scale",
    style: _vm.scaleStyle
  }, [_c('img', {
    staticClass: "vuejs-clipper-basic__img js-img",
    style: _vm.rotateStyle,
    attrs: {
      "src": _vm.src,
      "crossorigin": _vm.crossOrigin
    },
    on: {
      "load": function load($event) {
        _vm.imgLoaded();

        _vm.emit('load', $event);
      },
      "error": function error($event) {
        return _vm.emit('error', $event);
      }
    }
  })])])]), _c('div', {
    staticClass: "vuejs-clipper-basic__in-pad",
    style: _vm.inPadStyle
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__clip-area js-clip-area"
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__zoom-area js-zoom-area",
    style: _vm.posObj
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__extend vuejs-clipper-basic__extend--outer",
    style: _vm.exOuterStyle
  }), _c('div', {
    staticClass: "vuejs-clipper-basic__extend vuejs-clipper-basic__extend--inner",
    style: _vm.exInnerStyle
  }, [_c('div', {
    staticClass: "vuejs-clipper-basic__drag-inset js-drag-inset"
  })]), _vm.corner ? _c('div', _vm._l(4, function (index) {
    return _c('div', {
      key: 'corner' + index,
      staticClass: "vuejs-clipper-basic__corner",
      class: "vuejs-clipper-basic__corner".concat(index)
    });
  }), 0) : _vm._e(), _vm.grid ? _c('div', {
    staticClass: "vuejs-clipper-basic__grid"
  }, _vm._l(4, function (index) {
    return _c('div', {
      key: 'gridItem' + index,
      staticClass: "vuejs-clipper-basic__grid-item"
    });
  }), 0) : _vm._e(), _vm._t("vuejs-clipper-basic__area")], 2)])])]), _c('div', {
    staticClass: "vuejs-clipper-basic__placeholder",
    style: _vm.eptStyle
  }, [_vm._t("placeholder")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }